import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import Hero from './sections/Hero';
import About from './sections/About';
import Menu from './sections/Menu';
import OpenKitchen from './sections/OpenKitchen';
import Catering from './sections/Catering';
import PhotoCorner from './sections/PhotoCorner';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

const LandingPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="text-center">
          <img
            src="https://cdn1.sharemyimage.com/smi/2025/10/21/Logo-Lavie-Saigon.jpeg"
            alt="La Vie Saigon"
            className="h-16 w-16 mx-auto mb-4 rounded-full animate-pulse"
          />
          <h1 className="text-2xl font-playfair text-warm-brown mb-2">La Vie Saigon</h1>
          <p className="text-warm-brown/70">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream">
      <Link
        to="/login"
        className="fixed bottom-4 right-4 w-12 h-12 bg-warm-brown/80 hover:bg-warm-brown text-cream rounded-full flex items-center justify-center z-50 opacity-30 hover:opacity-100 transition-opacity"
        title="Admin Login"
        aria-label="Admin Login"
      >
        ⚙️
      </Link>
      <Hero />
      <About />
      <Menu />
      <OpenKitchen />
      <Catering />
      <PhotoCorner />
      <Contact />
      <Footer />
    </div>
  );
};

export default LandingPage;